/*
 * Contains the necessary methods for interacting with the browser
 */
export const BrowserMixin = {
  methods: {
    getUrlParameter ( name, location = window.location.href ) {
      // eslint-disable-next-line
      name = name.replace( /[\[]/, "\\[" ).replace( /[\]]/, "\\]" );
      const regex = new RegExp( `[\\?&]${name}=([^&#]*)` );
      const results = regex.exec( location );
      return results === null ? "" : decodeURIComponent( results[1].replace( /\+/g, " " ) );
    }
  }
};

/*
 * Contains the necessary methods for determining if the screen should be considered mobile
 */
export const IsMobileMixin = {
  data: () => ( {
    windowWidth: 0,
    maxMobileWidth: 992
  } ),
  mounted () {
    window.addEventListener( "resize", this.setScreenWidth );
  },
  unmounted () {
    window.removeEventListener( "resize", this.setScreenWidth );
  },
  computed: {
    isMobile () {
      return this.windowWidth < this.maxMobileWidth && window.innerWidth < this.maxMobileWidth;
    }
  },
  methods: {
    setScreenWidth () {
      this.windowWidth = window.innerWidth;
    }
  }
};

export const KeyEventCodes = {
  data: () => ( {
    keyboardEvent: {
      keyCode: {
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        ENTER: 13,
        SHIFT: 16,
        BACKSPACE: 8,
        CTRL: 7,
        TAB: 9,
        DELETE: 46
      }
    }
  } )
};
